import { useState } from 'react';

import { ExtraPageTitleContext } from '@app/providers/ExtraPageTitleProvider/ExtraPageTitleContext';
import type { NExtraPageTitleProvider } from '@app/providers/ExtraPageTitleProvider/ExtraPageTitleProvider.types';

export const ExtraPageTitleProvider: NExtraPageTitleProvider.Main = ({
  children,
}) => {
  const [titleData, setTitleData] = useState<string | JSX.Element>('');

  return (
    <ExtraPageTitleContext.Provider
      value={{
        titleData,
        setTitleData,
      }}
    >
      {children}
    </ExtraPageTitleContext.Provider>
  );
};
